export default {
  kiw: {
    accepted: [
      { text: 'Nazwa materiału', value: 'name', sortable: false },
      { text: 'Numer wniosku', value: 'reference', sortable: false },
      { text: 'Departament', value: 'department', sortable: false },
      { text: 'Cel przekazania materiału', value: 'purpose', sortable: false },
      { text: 'Status / Numer KIW', value: 'number', sortable: false },
      { text: 'Data dodania', value: 'updatedAt', sortable: false },
    ],
    pending: [
      {
        text: '',
        value: 'select',
        sortable: false,
        width: 50,
      },
      { text: 'Nazwa materiału', value: 'name', sortable: false },
      { text: 'Numer wniosku', value: 'reference', sortable: false },
      { text: 'Departament', value: 'department', sortable: false },
      { text: 'Cel przekazania materialu', value: 'purpose', sortable: false },
      { text: 'Ostatnia zmiana', value: 'updatedAt', sortable: false },
    ],
    rejected: [
      { text: 'Nazwa materiału', value: 'name', sortable: false },
      { text: 'Numer wniosku', value: 'reference', sortable: false },
      { text: 'Departament', value: 'department', sortable: false },
      { text: 'Cel przekazania materialu', value: 'purpose', sortable: false },
      { text: 'Ostatnia zmiana', value: 'updatedAt', sortable: false },
    ],
  },
  commercialPrint: {
    pending: [
      { text: 'Nazwa materiału', value: 'name', sortable: false },
      { text: 'Zespół zlecający', value: 'orderers', sortable: false },
      { text: 'Zespół projektowy', value: 'members', sortable: false },
      { value: 'bell', sortable: false, align: 'end' },
    ],
    workInProgress: [
      { text: 'Nazwa materiału', value: 'name', sortable: false },
      { text: 'Zespół zlecający', value: 'orderers', sortable: false },
      { text: 'Zespół projektowy', value: 'members', sortable: false },
      { value: 'bell', sortable: false, align: 'end' },
    ],
    creatorReview: [
      { text: 'Nazwa materiału', value: 'name', sortable: false },
      { text: 'Zespół zlecający', value: 'orderers', sortable: false },
      { text: 'Zespół projektowy', value: 'members', sortable: false },
      { value: 'bell', sortable: false, align: 'end' },
    ],
    printCoordinatorReview: [
      { text: 'Nazwa materiału', value: 'name', sortable: false },
      { text: 'Zespół zlecający', value: 'orderers', sortable: false },
      { text: 'Zespół projektowy', value: 'members', sortable: false },
      { value: 'bell', sortable: false, align: 'end' },
    ],
    adminReview: [
      { text: 'Nazwa materiału', value: 'name', sortable: false },
      { text: 'Zespół zlecający', value: 'orderers', sortable: false },
      { text: 'Zespół projektowy', value: 'members', sortable: false },
      { value: 'bell', sortable: false, align: 'end' },
    ],
    archived: [
      { text: 'Nazwa materiału', value: 'name', sortable: false },
      { text: 'Zespół zlecający', value: 'orderers', sortable: false },
      { text: 'Zespół projektowy', value: 'members', sortable: false },
      { value: 'bell', sortable: false, align: 'end' },
    ],
    rejected: [
      { text: 'Nazwa materiału', value: 'name', sortable: false },
      { text: 'Zespół zlecający', value: 'orderers', sortable: false },
      { text: 'Zespół projektowy', value: 'members', sortable: false },
      { text: 'Status', value: 'status', sortable: false },
      { value: 'bell', sortable: false, align: 'end' },
    ],
  },

  tpw: [
    { text: 'Tytuł', value: 'title', sortable: false },
    { text: 'Autor', value: 'author', sortable: false },
    { text: 'Informacje o prawach', value: 'info', sortable: false },
    { value: 'actions', sortable: false, align: 'end' },
  ],
  users: [
    { text: 'Użytkownik', value: 'name' },
    { text: 'Departament', value: 'departmentName' },
    { text: 'Uprawnienia', value: 'roles', sortable: false },
    { text: 'Adres e-mail', value: 'email' },
    { text: 'Data dodania', value: 'createdAt' },
    { value: 'actions', sortable: false, align: 'end' },
  ],
  userReplacement: [
    {
      text: 'Termin',
      value: 'timespan',
      sortable: false,
      width: 240,
    },
    { text: 'Zastępstwo', value: 'users', sortable: false },
    { value: 'actions', sortable: false, align: 'end' },
  ],
  projectChanges: [
    { text: 'Użytkownik', value: 'user', sortable: false },
    { text: 'Data zmiany', value: 'createdAt', sortable: false },
    { text: 'Rodzaj zmiany', value: 'changeType', sortable: false },
    { text: 'Zmiana', value: 'text', sortable: false },
  ],
};
